import { useEffect, useState } from "react";
import { setLiveCalls, useHub, useLiveCalls } from "../../core/Global";
import LiveCall from "../../modules/voice/calls/models/LiveCall";
import Div from "../base/Div";
import Icon from "../base/Icon";
import LiveCallItem from "./LiveCallItem";

interface IProps {
    onFetch?: (count: number) => void
}

function LiveCallsBoard(props: IProps) {

    const hub = useHub()
    const liveCalls = useLiveCalls()
    const [loading, setLoading] = useState(true)

    // Initial fetch: SignalR only sends incremental updates (add/update/end), so without this call
    // the board stays empty for any call that was already in progress when the page mounted.
    useEffect(() => {
        let cancelled = false
        hub.Get("/system/calls/live", res => {
            if (cancelled) return
            if (res.success && Array.isArray(res.data)) {
                const calls = res.data as LiveCall[]
                setLiveCalls(calls)
                props.onFetch?.(calls.length)
            }
            setLoading(false)
        })
        return () => { cancelled = true }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const empty = !loading && (liveCalls == null || liveCalls.length === 0)

    return (
        <Div>

            <Div visible={loading} className="p-10 text-center">
                <Icon icon="spinner-third" type="regular" spin size={36} className="mb-5" />
                <br />
                Loading...
            </Div>

            <Div visible={empty} className="p-10 text-center">
                <Icon icon="phone-rotary" size={46} type="solid" className="mb-5" />
                <br />
                There is No Live Call!
            </Div>

            <div className="row">
                {liveCalls?.map(item =>
                    <div key={item.id} className="col-12 col-sm-6 col-md-3 col-lg-3 col-xxxl-2">
                        <LiveCallItem call={item} />
                    </div>
                )}
            </div>

        </Div>
    )
}

export default LiveCallsBoard;
